import {createAsyncThunk} from "@reduxjs/toolkit";
import {api} from "../config/api";

export const fetchLatestPlayListsLanding = createAsyncThunk("latestPlayLists/fetchLatestPlayListsLanding", async () => {
    const response = await api.get(`/playlist/latest/landing/pages`);
    return response.data || [];
});

let couponCache = null;
let couponPromise = null;

export const fetchAdminCoupon = createAsyncThunk(
  "adminCoupon/fetch",
  async () => {
    if (couponCache) return couponCache;
    if (couponPromise) return couponPromise;

    couponPromise = api
      .get("/admin-coupon/")
      .then((response) => {
        couponCache = response.data;
        couponPromise = null;
        return response.data;
      })
      .catch((err) => {
        couponPromise = null;
        throw err;
      });

    return couponPromise;
  }
);